import _styled from "styled-components";
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useMedia } from "../../utils/useMedia";
import { Header } from "../Header/Header";
import { useDeviceData } from "../DeviceData/useDeviceData";
import { useDeviceApi } from "../DeviceData/useDeviceApi";
import { ToggledButton } from "../ToggledButton/ToggledButton";
import { usePathCreator } from "../Config/useLinkCreator";
import { SchedulePreview } from "../ScheduleCircle/SchedulePreview";
var weekDayNames = ["пн", "вт", "ср", "чт", "пт", "сб", "вс"];

var Container = _styled.div.withConfig({
  displayName: "SchedulePage__Container",
  componentId: "m0bhf4-0"
})(["flex:1;display:flex;flex-direction:column;"]);

var Title = _styled.div.withConfig({
  displayName: "SchedulePage__Title",
  componentId: "m0bhf4-1"
})(["font-size:24px;margin-top:60px;text-align:center;opacity:", ";"], function (props) {
  return props.manual ? 0.3 : 1;
});

var ToggleContainer = _styled.div.withConfig({
  displayName: "SchedulePage__ToggleContainer",
  componentId: "m0bhf4-2"
})(["display:flex;align-items:center;padding:20px;"]);

var ActivateTitle = _styled.div.withConfig({
  displayName: "SchedulePage__ActivateTitle",
  componentId: "m0bhf4-3"
})(["flex:1;font-size:24px;"]);

var WeekContainer = _styled.div.withConfig({
  displayName: "SchedulePage__WeekContainer",
  componentId: "m0bhf4-4"
})(["flex:1;margin-top:60px;display:flex;flex-direction:column;opacity:", ";align-self:center;a{-webkit-tap-highlight-color:rgba(255,255,255,0);pointer-events:", ";}"], function (props) {
  return props.manual ? 0.3 : 1;
}, function (props) {
  return props.manual ? "none" : "all";
});

var DaysRow = _styled.div.withConfig({
  displayName: "SchedulePage__DaysRow",
  componentId: "m0bhf4-5"
})(["display:flex;align-items:center;"]);

var DayContainer = _styled.div.withConfig({
  displayName: "SchedulePage__DayContainer",
  componentId: "m0bhf4-6"
})(["position:relative;display:flex;justify-content:center;margin-left:10px;&:first{margin-left:0;}"]);

var DayCircle = _styled.div.withConfig({
  displayName: "SchedulePage__DayCircle",
  componentId: "m0bhf4-7"
})(["position:absolute;width:96px;height:96px;top:50%;left:50%;transform:translate(-50%,-50%);border-radius:50%;background-color:#4d9adf;display:flex;justify-content:center;align-items:center;color:white;font-size:20px;@media screen and (max-width:419px){width:80px;height:80px;}"]);

export function SchedulePage() {
  var _useDeviceData = useDeviceData(),
      _useDeviceData$heatCo = _useDeviceData.heatConfig,
      manual = _useDeviceData$heatCo.manual,
      heatSchedule = _useDeviceData$heatCo.heatSchedule;

  var _useDeviceApi = useDeviceApi(),
      toggleManualMode = _useDeviceApi.toggleManualMode,
      toggleManualModeResult = _useDeviceApi.toggleManualModeResult;

  var pathCreator = usePathCreator();
  var isSmall = useMedia(["(max-width: 420px)"]);

  var handleManualModeToggle = function handleManualModeToggle() {
    return toggleManualMode();
  };

  var rows = useMemo(function () {
    return [heatSchedule.slice(0, 3), heatSchedule.slice(3, 6), heatSchedule.slice(6)];
  }, [heatSchedule]);
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Header, {
    backTo: pathCreator("/")
  }), /*#__PURE__*/React.createElement(Title, {
    manual: manual
  }, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0435\u043D\u044C \u043D\u0435\u0434\u0435\u043B\u0438"), /*#__PURE__*/React.createElement(WeekContainer, {
    manual: manual
  }, rows.map(function (row, rowIndex) {
    return /*#__PURE__*/React.createElement(DaysRow, {
      key: rowIndex
    }, row.map(function (daySchedule, dayIndex) {
      return /*#__PURE__*/React.createElement(Link, {
        key: dayIndex,
        to: pathCreator("/schedule/".concat(rowIndex * 3 + dayIndex))
      }, /*#__PURE__*/React.createElement(DayContainer, null, /*#__PURE__*/React.createElement(SchedulePreview, {
        ranges: daySchedule,
        size: isSmall ? 104 : 120
      }), /*#__PURE__*/React.createElement(DayCircle, null, weekDayNames[rowIndex * 3 + dayIndex])));
    }));
  })), /*#__PURE__*/React.createElement(ToggleContainer, null, /*#__PURE__*/React.createElement(ActivateTitle, null, "\u0410\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0433\u0440\u0430\u0444\u0438\u043A"), /*#__PURE__*/React.createElement(ToggledButton, {
    on: !manual,
    onChange: handleManualModeToggle,
    indeterminate: toggleManualModeResult.loading
  })));
}